module.exports = __webpack_public_path__ + "img/orgManage.a706c924.svg";